'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _css = require('antd/lib/table/style/css');

var _table = require('antd/lib/table');

var _table2 = _interopRequireDefault(_table);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _constants = require('../constants');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * 订单基础信息
 */

var OrderInfo = _react2.default.createClass({
    displayName: 'OrderInfo',
    render: function render() {
        var order = this.props.order;

        var columns = [{
            title: '基础信息',
            key: '0',
            render: function render(text, record) {
                return _react2.default.createElement(
                    'dl',
                    null,
                    _react2.default.createElement(
                        'dt',
                        null,
                        '\u8BA2\u5355\u7F16\u53F7\uFF1A'
                    ),
                    _react2.default.createElement(
                        'dd',
                        null,
                        order.id
                    ),
                    _react2.default.createElement('br', null),
                    _react2.default.createElement(
                        'dt',
                        null,
                        '\u5BA2\u6237\uFF1A'
                    ),
                    _react2.default.createElement(
                        'dd',
                        null,
                        order.buyer.name
                    ),
                    _react2.default.createElement('br', null),
                    _react2.default.createElement(
                        'dt',
                        null,
                        '\u4E0B\u5355\u65F6\u95F4\uFF1A'
                    ),
                    _react2.default.createElement(
                        'dd',
                        null,
                        order.created_at
                    ),
                    _react2.default.createElement('br', null),
                    _react2.default.createElement(
                        'dt',
                        null,
                        '\u8BA2\u5355\u72B6\u6001\uFF1A'
                    ),
                    _react2.default.createElement(
                        'dd',
                        null,
                        _constants.ORDER_STATUS[order.status]
                    )
                );
            }
        }, {
            title: '收货信息',
            key: '1',
            render: function render(text, record) {
                return _react2.default.createElement(
                    'dl',
                    null,
                    _react2.default.createElement(
                        'dt',
                        null,
                        '\u6536\u8D27\u4EBA\uFF1A'
                    ),
                    _react2.default.createElement(
                        'dd',
                        null,
                        order.receiver.name
                    ),
                    _react2.default.createElement('br', null),
                    _react2.default.createElement(
                        'dt',
                        null,
                        '\u624B\u673A\u53F7\uFF1A'
                    ),
                    _react2.default.createElement(
                        'dd',
                        null,
                        order.receiver.mobile
                    ),
                    _react2.default.createElement('br', null),
                    _react2.default.createElement(
                        'dt',
                        null,
                        '\u6240\u5728\u5730\uFF1A'
                    ),
                    _react2.default.createElement(
                        'dd',
                        null,
                        order.receiver.address.province + ' ' + order.receiver.address.city + ' ' + order.receiver.address.district
                    ),
                    _react2.default.createElement('br', null),
                    _react2.default.createElement(
                        'dt',
                        null,
                        '\u8BE6\u7EC6\u5730\u5740\uFF1A'
                    ),
                    _react2.default.createElement(
                        'dd',
                        null,
                        order.receiver.address.street
                    )
                );
            }
        }, {
            title: '配送信息',
            key: '2',
            render: function render(text, record) {
                return _react2.default.createElement(
                    'dl',
                    null,
                    _react2.default.createElement(
                        'dt',
                        null,
                        '\u5E94\u53D1\u8D27\u65E5\u671F\uFF1A'
                    ),
                    _react2.default.createElement(
                        'dd',
                        null,
                        record.package.due_date || '暂无'
                    ),
                    _react2.default.createElement('br', null),
                    _react2.default.createElement(
                        'dt',
                        null,
                        '\u914D\u9001\u65B9\u5F0F\uFF1A'
                    ),
                    _react2.default.createElement(
                        'dd',
                        null,
                        '\u5FEB\u9012'
                    ),
                    _react2.default.createElement('br', null),
                    _react2.default.createElement(
                        'dt',
                        null,
                        '\u627F\u8FD0\u4EBA\uFF1A'
                    ),
                    _react2.default.createElement(
                        'dd',
                        null,
                        record.package.carrier || '暂无'
                    ),
                    _react2.default.createElement('br', null),
                    _react2.default.createElement(
                        'dt',
                        null,
                        '\u5355\u53F7\uFF1A'
                    ),
                    _react2.default.createElement(
                        'dd',
                        null,
                        record.package.tracking_number || '暂无'
                    ),
                    _react2.default.createElement('br', null),
                    _react2.default.createElement(
                        'dt',
                        null,
                        '\u53D1\u8D27\u65F6\u95F4\uFF1A'
                    ),
                    _react2.default.createElement(
                        'dd',
                        null,
                        record.package.package_time || '暂无'
                    ),
                    _react2.default.createElement('br', null),
                    _react2.default.createElement(
                        'dt',
                        null,
                        '\u5230\u8D27\u65F6\u95F4\uFF1A'
                    ),
                    _react2.default.createElement(
                        'dd',
                        null,
                        record.package.arrival_time || '暂无'
                    )
                );
            }
        }, {
            title: '订单备注',
            key: '3',
            render: function render(text, record) {
                return _react2.default.createElement(
                    'dl',
                    null,
                    _react2.default.createElement(
                        'dt',
                        null,
                        '\u4E70\u5BB6\u5907\u6CE8\uFF1A'
                    ),
                    _react2.default.createElement(
                        'dd',
                        null,
                        order.notes.buyer
                    ),
                    _react2.default.createElement('br', null),
                    _react2.default.createElement(
                        'dt',
                        null,
                        '\u5356\u5BB6\u5907\u6CE8\uFF1A'
                    ),
                    _react2.default.createElement(
                        'dd',
                        null,
                        order.notes.seller
                    )
                );
            }
        }];
        var tableConfig = {
            columns: columns,
            dataSource: [order],
            pagination: false,
            bordered: true,
            rowKey: function rowKey(record) {
                return record.id;
            }
        };
        return _react2.default.createElement(
            'div',
            { id: 'order-info' },
            _react2.default.createElement(_table2.default, tableConfig)
        );
    }
});

exports.default = OrderInfo;


//////////////////
// WEBPACK FOOTER
// ./src/js/components/order_info.js
// module id = 1190
// module chunks = 0